"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { Line } from "react-chartjs-2"
import "chart.js/auto"
import "../styles/dashboardDono.css"
import atencao from "../assets/atencao.webp"
import moment from "moment"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js"

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

function DashboardDono() {
  const [eventos, setEventos] = useState([])
  const [eventoSelecionado, setEventoSelecionado] = useState("")
  const [periodo, setPeriodo] = useState(7)
  const [dados, setDados] = useState({})
  const [grafico, setGrafico] = useState({})
  const [options, setOptions] = useState({})
  const [mensagemAviso, setMensagemAviso] = useState("")
  const [showModal, setShowModal] = useState(false)
  const [usuario, setUsuario] = useState(null)
  const [vendasBoleto, setVendasBoleto] = useState("0.00")
  const [vendasManual, setVendasManual] = useState("0.00")


  useEffect(() => {
    if (usuario && usuario._id) {
      buscarEventos()
      buscarAviso(usuario._id)
    }
  }, [usuario])

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("usuario"))
    if (user) {
      setUsuario(user)
    }
  }, [])

  useEffect(() => {
    if (eventoSelecionado) {
      buscarDashboard()
    }
  }, [eventoSelecionado, periodo])

  useEffect(() => {
    buscarEventos()
  }, [])

  const buscarAviso = async (usuarioId) => {
    try {
      const token = localStorage.getItem("token")
      const res = await axios.get(`https://api.ticketdovaqueiro.com/api/avisos/${usuarioId}/dono`, {
        headers: { Authorization: `Bearer ${token}` },
      })

      if (res.data?.mensagem) {
        setMensagemAviso(res.data.mensagem)
        setShowModal(true)
      }
    } catch (error) {
      console.error("Erro ao buscar aviso:", error)
    }
  }

  const buscarEventos = async () => {
    try {
      const token = localStorage.getItem("token")
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/events/dono`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setEventos(res.data)
      if (res.data.length > 0) setEventoSelecionado(res.data[0]._id)
    } catch (error) {
      console.error("Erro ao buscar eventos", error)
    }
  }

  const buscarDashboard = async () => {
    try {
      const token = localStorage.getItem("token")
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/dono/dashboard`, {
        params: { eventoId: eventoSelecionado, periodo },
        headers: { Authorization: `Bearer ${token}` },
      })
      setDados(res.data)

      // GERA LISTA DE DIAS DO PERÍODO
      const hoje = moment()
      const dias = []
      for (let i = periodo - 1; i >= 0; i--) {
        dias.push(hoje.clone().subtract(i, "days").format("DD/MM/YYYY"))
      }

      // PREENCHE OS VALORES, coloca 0 se não teve venda
      const valores = dias.map((dia) => res.data.graficoDias[dia] || 0)

      setGrafico({
        labels: dias,
        datasets: [
          {
            label: "Total Vendas (R$)",
            data: valores,
            fill: "start",
            backgroundColor: "rgba(255, 231, 13, 0.2)",
            borderColor: "#f5c242",
            tension: 0.4,
            borderWidth: 2,
            pointBackgroundColor: "#f5c242",
          },
        ],
      })

      setOptions({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              color: "#fff",
              font: {
                size: 14,
              },
            },
          },
          tooltip: {
            mode: "index",
            intersect: false,
            bodyColor: "#fff",
            titleColor: "#fff",
            backgroundColor: "rgba(51, 51, 51, 0.9)",
            padding: 12,
            cornerRadius: 6,
            boxPadding: 6,
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#fff",
              font: {
                size: 12,
              },
            },
            grid: {
              color: "rgba(255, 255, 255, 0.1)",
              drawBorder: false,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              color: "#fff",
              font: {
                size: 12,
              },
            },
            grid: {
              color: "rgba(255, 255, 255, 0.1)",
              drawBorder: false,
            },
          },
        },
      })
      try {
        const token = localStorage.getItem("token")
        const resManual = await axios.get(`${process.env.REACT_APP_API_URL}/dono/financeiro/total-manual`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        setVendasManual(resManual.data.totalManual)
      } catch (err) {
        console.error("Erro ao buscar total manual", err)
      }

    } catch (err) {
      console.error("Erro ao buscar dashboard", err)
    }
    // Buscar total de vendas por boleto
    try {
      const token = localStorage.getItem("token")
      const resBoleto = await axios.get(`${process.env.REACT_APP_API_URL}/dono/financeiro/total-boleto`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setVendasBoleto(resBoleto.data.totalBoleto)
    } catch (err) {
      console.error("Erro ao buscar total por boleto", err)
    }
  }

  return (
    <div className="dashboard-dono-container">
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <img src={atencao || "/placeholder.svg"} alt="Atenção" className="aviso-conteudo-img" />
            <h3>Aviso</h3>
            <p>{mensagemAviso}</p>
            <button onClick={() => setShowModal(false)}>Fechar</button>
          </div>
        </div>
      )}
      <h2>Dashboard</h2>

      <div className="filtros-dashboard">
        <select value={eventoSelecionado} onChange={(e) => setEventoSelecionado(e.target.value)}>
          {eventos.map((ev) => (
            <option key={ev._id} value={ev._id}>
              {ev.nome}
            </option>
          ))}
        </select>

        <select value={periodo} onChange={(e) => setPeriodo(Number.parseInt(e.target.value))}>
          <option value={7}>Últimos 7 dias</option>
          <option value={15}>Últimos 15 dias</option>
          <option value={30}>Últimos 30 dias</option>
          <option value={60}>Últimos 60 dias</option>
        </select>
      </div>
      <div className="grafico-dashboard">
        {grafico.labels && <Line data={grafico} options={options} height={300} />}
      </div>
      <div className="cards-dashboard">
        <div className="card">
          <h4>Total em Vendas</h4>
          <p>R$ {dados.totalVendas || "0.00"}</p>
        </div>
        <div className="card">
          <h4>Vendas Pagas</h4>
          <p>{dados.numeroVendas || "0"}</p>
        </div>
        <div className="card">
          <h4>Total Pendente</h4>
          <p>R$ {dados.totalPendente || "0.00"}</p>
        </div>
        <div className="card">
          <h4>Vendas Pendentes</h4>
          <p>{dados.numeroVendasPendentes || "0"}</p>
        </div>
        <div className="card">
          <h4>Ticket Médio</h4>
          <p>R$ {dados.ticketMedio || "0.00"}</p>
        </div>
        <div className="card">
          <h4>Vendas por PIX</h4>
          <p>R$ {dados.totalPix || "0.00"}</p>
        </div>
        <div className="card">
          <h4>Vendas por Cartão</h4>
          <p>R$ {dados.totalCartao || "0.00"}</p>
        </div>
        <div className="card">
          <h4>Vendas por Boleto</h4>
          <p>R$ {vendasBoleto}</p>
        </div>
        <div className="card">
          <h4>Vendas Manuais</h4>
          <p>R$ {vendasManual}</p>
        </div>
        <div className="card">
          <h4>Reembolsos</h4>
          <p>{dados.numeroReembolsos || "0"}</p>
        </div>
        <div className="card">
          <h4>Total em Reembolso</h4>
          <p>R$ {dados.totalReembolso || "0.00"}</p>
        </div>
      </div>

      
    </div>
  )
}

export default DashboardDono

